import { createSlice } from '@reduxjs/toolkit'
import { fetchStockHoldersEquity } from './thunks/stockHoldersEquity';

const initialState = {
    data: "",
    isLoading: false,
    error: null,
    isNoteActive: false
}

const stockHolderEquity = createSlice({
    name: 'STOCKHOLDEREQUITY',
    initialState,
    reducers: {
        addSymbols(state, action){
            state.availableSymbols = action.payload
        },
        setEsNoteActiveState(state, action){
          state.isNoteActive = !state.isNoteActive
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchStockHoldersEquity.pending, (state) => {
          state.isLoading = true
        })
        builder.addCase(fetchStockHoldersEquity.fulfilled, (state, action) => {
          state.isLoading = false
          state.data = action.payload
        })
        builder.addCase(fetchStockHoldersEquity.rejected, (state, action) => {
          state.isLoading = false
          state.error = action.error.message
          state.data = null
        })
    }
});

export const { addSymbols, data, setEsNoteActiveState } = stockHolderEquity.actions

export default stockHolderEquity;